export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.5-0944.38",
  commitId: "7340053ff3a722ae9b390d4aca3ef36a29a5e906",
  commitTime: "2026-05-05T09:44:38.000Z",
});
